import { memo } from 'react';
import Date from './Date';
import Range from './range';

// eslint-disable-next-line react/display-name
export default memo((props) => <Range {...props} component={Date} />);
